export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9954.e5b5bc45.jpg";